import React from 'react';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageAnswers,
  PageScores,
  PageRankings,
  PageArticleStats,
  PageAchievements,
  PageParticipations,
} from '../pages/reports';

const RouteAnswers = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${path}/scores`} />
      </Route>
      <Route exact path={`${path}/scores`}>
        <PageAnswers />
      </Route>
      <Route exact path={`${path}/performance`}>
        <PageScores />
      </Route>
      <Route exact path={`${path}/rankings`}>
        <PageRankings />
      </Route>
      <Route exact path={`${path}/articles`}>
        <PageArticleStats />
      </Route>
      <Route exact path={`${path}/achievements`}>
        <PageAchievements />
      </Route>
      <Route exact path={`${path}/participations`}>
        <PageParticipations />
      </Route>
    </Switch>
  );
};

export default RouteAnswers;
